import axios from 'axios';
import axiosInstance from '../services/AxiosInstance';
import { store } from '../store/store';

const getAuthHeaders = () => {
  const token = store.getState()?.auth?.auth?.accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const downloadFundRequestInvoice = (id) => {
  return axios.get(`${process.env.REACT_APP_BASE_URL}/merchant-balance-histories/download-invoice/${id}`, {
    responseType: 'blob',
    withCredentials: true,
    headers: {
      ...getAuthHeaders(),
      'Cache-Control': 'no-cache',
    },
  });
};

export const getFundRequests = (getData) => {
  return axiosInstance.get("merchant-balance-histories/list", {
    params: getData,
  });
};

export const getMercahntFundRequests = (id, getData) => {
  return axiosInstance.get(`merchant-balance-histories/merchant-funds/${id}`, {
    params: getData,
  });
};

export const addFundRequests = (data) => {
  return axiosInstance.post("merchant-balance-histories/create", data);
};

export const getFundRequestsCount = (data) => {
  return axiosInstance.get("merchant-balance-histories/details", {
    params: data,
  });
};

export const updateFundRequests = (id, data) => {
  return axiosInstance.put(`merchant-balance-histories/update/${id}`, data);
};

export const fetchFundRequestsById = async (id) => {
    const response = await axiosInstance.get(`merchant-balance-histories/show/${id}`);
    return response.data;
};
